import {setOAuthFlowCookie} from './setOAuthFlowCookie';

const EXPIRED_COOKIE_MAX_AGE = 0;

export const clearOAuthFlowCookie = () => {
  setOAuthFlowCookie('', '', EXPIRED_COOKIE_MAX_AGE);
  // Cookie reads do not expose Domain; remove the flow at each possible initiating parent.
  const labels = window.location.hostname.split('.');
  for (const [index] of labels.entries()) {
    setOAuthFlowCookie('', labels.slice(index).join('.'), EXPIRED_COOKIE_MAX_AGE);
  }
};
